import PasswordManager from './components/passwordManager'
import './App.css'

const App = () => <PasswordManager />

export default App
